import { env } from 'cloudflare:workers';
import { createServerFn } from '@tanstack/react-start';
import { createFileRoute } from '@tanstack/react-router';
import { Render } from '@puckeditor/core';
import { PUCK_CONFIG } from '~/editor/config';
import MicrositeWrapper from '~/components/MicrositeWrapper';
import { DEMO_CONFIG } from '~/demo';
import css from 'modern-normalize/modern-normalize.css?url';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { type SerializedPuckData } from '~/editor/SerializedPuckData';

interface Loader {
	title: string;
	puck: SerializedPuckData;
}

const getMicrositePreviewPuck = createServerFn()
	.inputValidator((data: { id: string }) => data)
	.handler(async ({ data }): Promise<Loader> => {
		const actor = env.MicrositeDurableObject.getByName(data.id);

		return {
			title: 'Microsite Preview',
			puck: await actor.getEditorPuck(),
		};
	});

export const Route = createFileRoute('/id/$id/preview')({
	loader: async ({ params }) => {
		return await getMicrositePreviewPuck({ data: { id: params.id } });
	},
	component,
	head: ({ loaderData }) => ({
		meta: [
			{
				title: loaderData?.title,
			},
			{
				name: 'viewport',
				content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0, viewport-fit=cover',
			},
		],
		links: [
			{ rel: 'stylesheet', href: css },
			{ rel: 'preconnect', href: 'https://fonts.googleapis.com' },
			{ rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
			{ rel: 'stylesheet', href: DEMO_CONFIG.theme.font.family.url },
		],
	}),
});

function component() {
	const cache = createCache({
		key: 'microsite',
	});

	const { puck } = Route.useLoaderData();

	return (
		<CacheProvider value={cache}>
			<MicrositeWrapper config={DEMO_CONFIG} data={puck}>
				<Render config={PUCK_CONFIG} data={puck} />
			</MicrositeWrapper>
		</CacheProvider>
	);
}
